import { graphql } from "react-relay";
import "./tailored-defrag-summary-events-moved-list/TailoredDefragSummaryEventsMovedList.gql";
import "./tailored-defrag-summary-attendee-stats/TailoredDefragSummaryAttendeeStats.gql";
import "./tailored-defrag-summary-attendee-stats/TailoredDefragSummaryAttendees.gql";

export const fragments = {
  org: graphql`
    fragment TailoredDefragSummaryCard_org on Org {
      ...TailoredDefragSummaryAttendeeStats_org
      id
      tailoredDefragCardSummary {
        __typename
        ... on TailoredDefragCardSummary {
          ...TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary
          defragTime
          impactedOtherCalendarIds
          valueStrings
          yourEventMoves {
            ...TailoredDefragSummaryEventsMovedList_eventsMoved
            newStartTime {
              dateOrDateTime
            }
            originalStartTime {
              dateOrDateTime
            }
            moveReasons
            addedRooms
            removedRooms
            event {
              title
              eventKey {
                externalEventId
              }
            }
          }
          persons {
            __typename
            ... on PersonList {
              list {
                primaryEmail
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
              }
            }
          }
          rooms {
            __typename
            ... on RoomList {
              ...TailoredDefragSummaryEventsMovedList_rooms
              list {
                roomId
                name
              }
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};

export const query = graphql`
  query TailoredDefragSummaryCardQuery($orgId: ID!) {
    org: node(id: $orgId) {
      ... on Org {
        ...TailoredDefragSummaryCard_org
        tailoredDefragCardSummary {
          __typename
          ... on TailoredDefragCardSummary {
            yourEventMoves {
              event {
                title
              }
            }
          }
        }
      }
    }
  }
`;
